/** Extract a readable string from API / caught errors */
export const getErrorMessage = (err, fallback = 'Something went wrong') => {
  if (!err) return fallback;
  if (typeof err === 'string') return err;
  if (err.message && typeof err.message === 'string') return err.message;
  if (err.error && typeof err.error === 'string') return err.error;
  try {
    return JSON.stringify(err);
  } catch {
    return fallback;
  }
};
